import React, { Component } from 'react';
import './styles.css';
import '../../../node_modules/fullcalendar-reactwrapper/dist/css/fullcalendar.min.css';
import '../../../node_modules/jquery-mobile/css/themes/default/jquery.mobile.theme.css';
import FullCalendar from 'fullcalendar-reactwrapper';
import config from "../../config";
import store from 'store2';
import connect from "react-redux/es/connect/connect";
import { changeDueDate } from '../../api/calendar';
import toPdf from '../../helpers/toPdf';

class Calendar extends Component {

  onDownloaded = (mainButton) => {
    mainButton.disabled = false;
    mainButton.innerText = 'Generate Pdf';
  };
  convertCalendarToPdf = () => {
    const mainButton = document.querySelectorAll('.fc-myCustomButton-button')[0];
    mainButton.disabled = true;
    mainButton.innerText = 'Loading...';
    const fullCalendar = document.getElementById('full-calendar');
    const toolbarOfCalendar = document.querySelectorAll('#full-calendar .fc-toolbar')[ 0 ];
    const mainPartOfCalendar = document.querySelectorAll('#full-calendar tbody')[ 0 ];
    const titleOfCalendar = document.querySelectorAll('#full-calendar .fc-header-toolbar .fc-center h2')[ 0 ].innerText;
    const fileName = `Calendar_${titleOfCalendar}`;
    const divHeight = mainPartOfCalendar.scrollHeight + toolbarOfCalendar.scrollHeight + 20;
    const divWidth = mainPartOfCalendar.scrollWidth;
    const ratio = divHeight / divWidth;
    toPdf(fullCalendar, fileName, ratio, divHeight, divWidth, () => this.onDownloaded(mainButton));
  };

  moveToTask = (id) => {
    localStorage.setItem('cameToWOFrom', 'quotes-wo');
    window.location = '/pages/task/' + id;
  };

  render() {
    const today = new Date();
    let tmpYear = today.getFullYear();
    let tmpMonth = today.getMonth();
    let tmpDay = today.getDate();
    let tmpView = 'month';
    let vars = window.location.search.split("&");
    for (let i = 0; i < vars.length; i++)
    {
      if (vars[i].match("^\\?year")) tmpYear = vars[i].substring(6);
      if (vars[i].match("^month")) tmpMonth = vars[i].substring(6) - 1;
      if (vars[i].match("^day")) tmpDay = vars[i].substring(4);
      if (vars[i].match("^view")) tmpView = vars[i].substring(5);
    }
    const { changeDueDateFunc } = this.props;
    const userAuth = store.get('user');
    return (
      <div id="calendar" className="fc fc-unthemed fc-ltr ui-content ui-page-theme-a">
        <FullCalendar
          defaultDate={new Date(tmpYear, tmpMonth, tmpDay)}
          defaultView={tmpView}
          customButtons={{
            myCustomButton: {
              text: 'Generate Pdf',
              click: (context) => this.convertCalendarToPdf(context)
            }
          }}
          id="full-calendar"
          viewRender={
            (view) => {
              let moment = view.intervalStart;
              if (moment) {
                window.history.pushState(null, null, 'calendar?year=' + moment.format('YYYY') + '&month=' + ( moment.format('M')
              ) + '&day=' + moment.format('DD') + '&view=' + view.type);
              }
          }
          }
          header={{
            left: 'prev,next today',
            center: 'title',
            right: 'myCustomButton month,agendaWeek,agendaDay,listWeek'
          }}
          eventRender={(event, element) => {
            element[ 0 ].innerHTML = `
            <span onclick="
              localStorage.setItem('cameToWOFrom', 'calendar');
              window.location = '/pages/task/' + ${event.taskId};">
                ${element[ 0 ].innerHTML}
            </span>
                <span class="info-calendar" onclick="
                    localStorage.setItem('cameToWOInfoFrom', 'calendar');
                    window.location = '/pages/dashboard-pre-view/' + ${event.taskId};"
                >
                    <span class="fa-stack" style="color: #3388cc; cursor: pointer;">
                        <i class="fa fa-circle fa-stack-2x"></i>
                        <i class="fa fa-info fa-stack-1x fa-inverse"></i>
                    </span>
                </span>`;
          }}
          navLinks={true} // can click day/week names to navigate views
          editable={true}
          eventLimit={true} // allow "more" link when too many events
          events={{
            url: `${config.apiEndpoint}/calendar/get_events`,
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          }}
          eventDrop={(event, delta, revertFunc) => {
            const data = {
              date: event.start.format('M/D/YYYY h:mm a'),
              id: event.taskId,
            };
            changeDueDateFunc(data, revertFunc);
          }}
        />
      </div>
    );
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    changeDueDateFunc: (data, revertFunc) => {
      changeDueDate(data, revertFunc)(dispatch);
    },
  }
};

export default connect(() => ({}), mapDispatchToProps)(Calendar);




// WEBPACK FOOTER //
// ./src/containers/Calendar/index.js